import { getSlug } from "./getSlug";

export const getAuthor = (page) => {
  let author;
  if (
    page.authorPersonType === "tourLeader" &&
    page.authorTourLeader &&
    page.authorTourLeader.title
  ) {
    author = {
      name: page.authorTourLeader.title,
      link: getSlug(page.authorTourLeader),
    };
  } else if (page.authorPersonType === "expert") {
    if (page.authorExpert && page.authorExpert.title) {
      author = {
        name: page.authorExpert.title,
        link: getSlug(page.authorExpert),
      };
    } else {
      author = {
        name: "The Kirker Team",
        link: "/about/our-expert-team/",
      };
    }
  } else if (
    page.authorPersonType === "artist" &&
    page.authorArtist &&
    page.authorArtist.title
  ) {
    author = {
      name: page.authorArtist.title,
      link: getSlug(page.authorArtist),
    };
  }
  return author;
};
